import React, {Fragment} from "react";
import styled from "styled-components";
import iconLoading from "assets/icons/icon_loading.gif";
import {Error} from "layouts";

export const Block = ({isLoading, isError, onRefresh, children, ...props}) => {
	return (
		<div {...props}>
			{(isError) ? <Error mode="section" onRefresh={onRefresh} /> : children}
			{(isLoading) ? <StyledDiv></StyledDiv> : null}
		</div>
	);
};

const StyledDiv = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: rgba(255,255,255,0.85) url(${iconLoading}) no-repeat center center / 50px;
	z-index: 8
`;

export default Block;



